var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2166_4519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.02 0.97951C18.3831 0.370887 17.536 0.03125 16.655 0.03125C15.774 0.03125 14.927 0.370887 14.29 0.97951L1.34251 13.927C0.915771 14.3514 0.5774 14.8562 0.346966 15.4122C0.116532 15.9682 -0.00139215 16.5643 1.24005e-05 17.1662V18.7495C1.24005e-05 19.081 0.131708 19.399 0.366129 19.6334C0.600549 19.8678 0.918492 19.9995 1.25001 19.9995H2.83335C3.43547 20.0011 4.03194 19.8833 4.58823 19.6529C5.14452 19.4224 5.64958 19.084 6.07418 18.657L19.02 5.70951C19.6463 5.08179 19.9981 4.23126 19.9981 3.34451C19.9981 2.45776 19.6463 1.60723 19.02 0.97951ZM4.30501 16.8895C3.91367 17.2783 3.385 17.4975 2.83335 17.4995H2.50001V17.1662C2.50172 16.614 2.72087 16.0847 3.11001 15.6928L12.75 6.05534L13.9442 7.24951L4.30501 16.8895ZM17.25 3.94201L15.7117 5.48284L14.5167 4.28784L16.0583 2.74951C16.2191 2.59583 16.433 2.51006 16.6554 2.51006C16.8779 2.51006 17.0917 2.59583 17.2525 2.74951C17.4097 2.90831 17.4976 3.12285 17.4972 3.34628C17.4967 3.5697 17.4078 3.78387 17.25 3.94201Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2166_4519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.4c97b105bba93d117eac722aad31f338.svg";
export { ForwardRef as ReactComponent };